"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapPageElement = wrapPageElement;

var _consent = _interopRequireDefault(require("./utils/consent"));

function wrapPageElement({
  element,
  props: {
    navigate,
    location
  }
}) {
  (0, _consent.default)(() => navigate(location.pathname));
  return element;
}